import { createSlice } from '@reduxjs/toolkit'

import { planningStopsAdapter } from '../adapters/planningStopsAdapter'

export const initialPlanningStopState = planningStopsAdapter.getInitialState()

export const planningStopsSlice = createSlice({
  name: 'stops',
  initialState: initialPlanningStopState,
  reducers: {
    upsertMultiplePlanningStops: (state, action) => {
      planningStopsAdapter.upsertMany(state, action.payload)
    },
    replaceAllPlanningStops: (state, action) => {
      planningStopsAdapter.setAll(state, action.payload)
    },
  },
})

export const { upsertMultiplePlanningStops, replaceAllPlanningStops } = planningStopsSlice.actions
